/* Bea Joyas — Motion (port fiel de motion.jsx): cursor de joyería, tilt 3D + glare, magnetic, scroll progress, parallax.
   Vanilla JS. Respeta prefers-reduced-motion y solo activa cursor/tilt/magnetic en dispositivos hover+fine. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function canHover() { return window.matchMedia('(hover:hover) and (pointer:fine)').matches; }

  var css = '' +
    '.cursor-none, .cursor-none *{cursor:none !important;}' +
    '.cursor-none shopify-forms-embed,.cursor-none [id^="app-embed-container"],.cursor-none [id^="shopify-form"]{cursor:auto !important;}' +
    '.bj-cursor-native .cur-ring,.bj-cursor-native .cur-dot,.bj-cursor-native .cur-layer{opacity:0 !important;}' +
    '.cur-layer{position:fixed;inset:0;z-index:9998;pointer-events:none;transition:opacity .3s;}' +
    '.cur-ring{position:fixed;top:0;left:0;z-index:9999;pointer-events:none;color:var(--clay-deep);width:40px;height:40px;will-change:transform;transition:color .2s;}' +
    '.cur-ring svg{display:block;transition:transform .3s var(--ease),opacity .3s;}' +
    '.cur-ring .cur-gem{position:absolute;top:50%;left:50%;width:7px;height:7px;transform:translate(-50%,-50%) rotate(45deg);background:var(--clay-deep);opacity:0;transition:opacity .25s;}' +
    '.cur-ring.is-hover svg{transform:scale(1.5);opacity:.9;}' +
    '.cur-ring.is-hover{color:var(--clay);}' +
    '.cur-ring.is-down svg{transform:scale(1.15);}' +
    '.cur-ring.is-text svg{opacity:0;}' +
    '.cur-ring.is-text .cur-gem{opacity:1;height:18px;width:1.5px;background:var(--ink);border-radius:2px;}' +
    '.cur-dot{position:fixed;top:0;left:0;z-index:10000;pointer-events:none;width:6px;height:6px;border-radius:50%;background:var(--ink);will-change:transform;}' +
    '.cur-spark{position:fixed;z-index:9998;pointer-events:none;width:var(--sz);height:var(--sz);transform:translate(-50%,-50%) rotate(var(--r));animation:sparkPop .7s var(--ease) forwards;}' +
    '.cur-spark::before,.cur-spark::after{content:"";position:absolute;inset:0;background:var(--clay);clip-path:polygon(50% 0,58% 42%,100% 50%,58% 58%,50% 100%,42% 58%,0 50%,42% 42%);}' +
    '.cur-spark::after{transform:scale(.5);background:#fff;}' +
    '@keyframes sparkPop{0%{opacity:0;transform:translate(-50%,-50%) rotate(var(--r)) scale(.2);}30%{opacity:1;}100%{opacity:0;transform:translate(-50%,-50%) rotate(var(--r)) scale(1.1);}}' +
    '@media (prefers-reduced-motion: reduce){.cur-spark{display:none;}}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function el(tag, cls) { var n = document.createElement(tag); if (cls) n.className = cls; return n; }

  function initCursor() {
    if (!canHover()) return;
    document.documentElement.classList.add('cursor-none');
    var layer = el('div', 'cur-layer'), ring = el('div', 'cur-ring'), dot = el('div', 'cur-dot');
    ring.innerHTML = '<svg viewBox="0 0 40 40" width="40" height="40"><circle cx="20" cy="20" r="18" fill="none" stroke="currentColor" stroke-width="1.2"/></svg><span class="cur-gem"></span>';
    document.body.appendChild(layer); document.body.appendChild(ring); document.body.appendChild(dot);
    var mx = innerWidth / 2, my = innerHeight / 2, rx = mx, ry = my, down = false, lastSpark = 0, lastX = mx, lastY = my;
    function spark(x, y) {
      var s = document.createElement('span'); s.className = 'cur-spark';
      s.style.left = x + 'px'; s.style.top = y + 'px';
      s.style.setProperty('--r', (Math.random() * 90 - 45) + 'deg');
      s.style.setProperty('--sz', (5 + Math.random() * 5) + 'px');
      layer.appendChild(s); setTimeout(function () { s.remove(); }, 700);
    }
    window.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      dot.style.transform = 'translate(' + mx + 'px,' + my + 'px) translate(-50%,-50%) scale(' + (down ? 0.6 : 1) + ')';
      var dist = Math.hypot(mx - lastX, my - lastY), now = performance.now();
      if (!reduce && dist > 6 && now - lastSpark > 55) { lastSpark = now; lastX = mx; lastY = my; spark(mx + (Math.random() * 14 - 7), my + (Math.random() * 14 - 7)); }
    });
    window.addEventListener('mouseover', function (e) {
      // Sobre el popup de Shopify Forms (shadow DOM, z-index máximo) el cursor custom queda tapado:
      // apagamos el custom y dejamos el nativo (lo natural en un formulario).
      var overForm = !!(e.target.closest && e.target.closest('shopify-forms-embed,[id^="app-embed-container"],[id^="shopify-form"]'));
      document.documentElement.classList.toggle('bj-cursor-native', overForm);
      var t = e.target.closest('a,button,[role="button"],input,select,textarea,[data-cursor="hover"]');
      ring.classList.toggle('is-hover', !!t && !t.closest('input,textarea,select'));
      ring.classList.toggle('is-text', !!(e.target.closest('input,textarea')));
    });
    window.addEventListener('mousedown', function () { down = true; ring.classList.add('is-down'); });
    window.addEventListener('mouseup', function () { down = false; ring.classList.remove('is-down'); });
    document.addEventListener('mouseleave', function () { layer.style.opacity = '0'; });
    document.addEventListener('mouseenter', function () { layer.style.opacity = '1'; });
    (function loop() { rx += (mx - rx) * 0.18; ry += (my - ry) * 0.18; ring.style.transform = 'translate(' + rx + 'px,' + ry + 'px) translate(-50%,-50%)'; requestAnimationFrame(loop); })();
  }

  function initTilt() {
    if (reduce || !canHover()) return;
    document.querySelectorAll('[data-bea-tilt]').forEach(function (n) {
      var max = parseFloat(n.getAttribute('data-bea-tilt')) || 7;
      n.addEventListener('mousemove', function (e) {
        var r = n.getBoundingClientRect(), px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
        n.style.transform = 'perspective(800px) rotateY(' + (px * max) + 'deg) rotateX(' + (-py * max) + 'deg) scale(1)';
        n.style.setProperty('--gx', (px * 100 + 50) + '%');
      });
      n.addEventListener('mouseleave', function () { n.style.transform = 'perspective(800px) rotateY(0) rotateX(0) scale(1)'; });
    });
  }

  function initMagnetic() {
    if (reduce || !canHover()) return;
    document.querySelectorAll('[data-bea-magnetic]').forEach(function (n) {
      var s = parseFloat(n.getAttribute('data-bea-magnetic')) || 0.35;
      n.addEventListener('mousemove', function (e) {
        var r = n.getBoundingClientRect();
        n.style.transform = 'translate(' + ((e.clientX - (r.left + r.width / 2)) * s) + 'px,' + ((e.clientY - (r.top + r.height / 2)) * s) + 'px)';
      });
      n.addEventListener('mouseleave', function () { n.style.transform = 'translate(0,0)'; });
    });
  }

  function initScrollProgress() {
    var bar = el('div'); bar.style.cssText = 'position:fixed;top:0;left:0;right:0;height:3px;z-index:60;pointer-events:none';
    var fill = el('div'); fill.style.cssText = 'height:100%;transform-origin:0 50%;transform:scaleX(0);background:linear-gradient(90deg,var(--clay),var(--rose),var(--clay-deep))';
    bar.appendChild(fill); document.body.appendChild(bar);
    function onScroll() { var h = document.documentElement.scrollHeight - innerHeight; fill.style.transform = 'scaleX(' + (h > 0 ? scrollY / h : 0) + ')'; }
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  function initParallax() {
    if (reduce) return;
    var els = document.querySelectorAll('[data-bea-parallax]');
    if (!els.length) return;
    window.addEventListener('scroll', function () {
      els.forEach(function (n) {
        var sp = parseFloat(n.getAttribute('data-bea-parallax')) || 0.08;
        var r = n.getBoundingClientRect();
        n.style.setProperty('--py', (((r.top + r.height / 2 - innerHeight / 2) * -sp).toFixed(1)) + 'px');
      });
    }, { passive: true });
  }

  function init() { initCursor(); initTilt(); initMagnetic(); initScrollProgress(); initParallax(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
